import {FILTER_MODE_NOT_IN} from "../../utils/sdmxJson";

export const TREE_FILTER_MAX_LENGTH = 6400;
export const TREE_NODE_KEY_PREFIX = 'TREE_NODE_KEY_';

export const getTreeFilterStrFromObj = (filterObj, colNames) => {
  return filterObj && Object.keys(filterObj).length > 0 && colNames !== null
    ? (
      colNames
        .filter(name => filterObj[name] !== undefined && filterObj[name].values.length > 0)
        .map(name =>
          `(${name} ${filterObj[name].mode === FILTER_MODE_NOT_IN ? "NOT IN" : "IN"} ` +
          `(${filterObj[name].values
            .filter(val => !(val && val.startsWith(TREE_NODE_KEY_PREFIX)))
            .map(val => `'${val}'`)
            .join(",")}))`
        )
        .join(" AND ")
    )
    : '';
};

export const getTreeFilterObjFromStr = filterStr => {

  let res = {};

  if (filterStr !== null && filterStr.length > 0) {
    const pairs =
      filterStr
        .split(') AND (')
        .map((block, index, arr) => {
          let res = block;
          if (index === 0) {
            res = res.substr(1);
          }
          if (index === arr.length - 1) {
            res = res.substr(0, res.length - 1);
          }
          return res;
        })
        .map(block => {
          if (block.includes("TIME_PERIOD")) {
            return ({
              colName: block.includes("ID_TIME_PERIOD") ? "ID_TIME_PERIOD" : "TIME_PERIOD",
              mode: "IN",
              values: [block.includes(">=") ? block.split(">= '")[1].split("'")[0] : null, block.includes("<=") ? block.split("<= '")[1].split("'")[0] : null]
            });
          } else {
            return block.includes(" NOT IN ")
              ? ({
                colName: block.split(" NOT IN")[0],
                mode: "NOT IN",
                values: block.split(" NOT IN ")[1].substr(1, block.split(" NOT IN ")[1].length - 2).split(",").map(val => val.substr(1, val.length - 2))
              })
              : ({
                colName: block.split(" IN ")[0],
                mode: "IN",
                values: block.split(" IN ")[1].substr(1, block.split(" IN ")[1].length - 2).split(",").map(val => val.substr(1, val.length - 2))
              });
          }
        });
    pairs.forEach(({colName, mode, values}) => res[colName] = ({mode, values}));
  }

  return res;
};

export const convertFilterStrWithSimpleFilterForTimePeriod = str => {
  if (str.includes("TIME_PERIOD IN")) {

    const colName = str.includes("ID_TIME_PERIOD") ? "ID_TIME_PERIOD" : "TIME_PERIOD";

    const replaceStart = str.indexOf(colName);
    const replaceEnd = replaceStart + str.substr(replaceStart).indexOf(")");

    const strToReplace = str.substr(replaceStart, replaceEnd - replaceStart + 1);

    const from = strToReplace.split(",")[0].split("(")[1];
    const to = strToReplace.split(",")[1].split(")")[0];

    const fromStr = from !== "'null'" ? `${colName} >= ${from}` : null;
    const toStr = to !== "'null'" ? `${colName} <= ${to}` : null;

    if (fromStr && toStr) {
      return str.replace(strToReplace, `${fromStr} AND ${toStr}`);
    } else if (fromStr) {
      return str.replace(strToReplace, fromStr);
    } else {
      return str.replace(strToReplace, toStr);
    }

  } else {
    return str;
  }
}

export const getDateTimeStrFromTimePeriodColumnVal = (val, isTo) => {

  let y, m, d;

  if (!val.includes("-")) { // 2020

    y = val;
    m = isTo ? 12 : 1;
    d = isTo ? 31 : 1;

  } else {

    y = Number(val.split("-")[0]);

    if (val.includes("Q")) { // 2020-Q4

      const q = Number(val.split("Q")[1]);

      if (isTo) {
        m = q * 3;
        d = (q === 2 || q === 3) ? 30 : 31
      } else {
        m = (q - 1) * 3 + 1;
        d = 1;
      }

    } else if (val.includes("S")) { // 2020-S2

      const s = Number(val.split("S")[1]);

      if (isTo) {
        m = s * 6;
        d = (s === 1) ? 30 : 31
      } else {
        m = (s - 1) * 6 + 1;
        d = 1;
      }

    } else { // 2020-12

      m = Number(val.split("-")[1]);

      if (isTo) {
        if (m === 4 || m === 6 || m === 9 || m === 11) {
          d = 30;
        } else if (m === 2) {
          if (((y % 4 === 0) && (y % 100 !== 0)) || (y % 400 === 0)) { // leap year
            d = 29;
          } else {
            d = 28;
          }
        } else {
          d = 31;
        }
      } else {
        d = 1;
      }
    }
  }

  return String(y).padStart(4, "0") +
    "-" + String(m).padStart(2, "0") +
    "-" + String(d).padStart(2, "0") +
    "T00:00:00.000Z";
};

export const getTimePeriodColumnValFromDateTimeStr = (str, freq) => {

  const [y, m] = str.split("T")[0].split("-");

  if (freq === "A") {
    return y;
  } else if (freq === "S") {
    const res = y + "-S";
    if (Number(m) <= 6) {
      return res + "1";
    } else {
      return res + "2";
    }
  } else if (freq === "Q") {
    const res = y + "-Q";
    if (Number(m) <= 3) {
      return res + "1";
    } else if (Number(m) <= 6) {
      return res + "2";
    } else if (Number(m) <= 9) {
      return res + "3";
    } else {
      return res + "4";
    }
  } else {
    return y + "-" + m;
  }

};

export const getBestFrequency = frequencies => {
  if (!frequencies) {
    return "A";
  } else if (frequencies.includes("M")) {
    return "M";
  } else if (frequencies.includes("Q")){
   return "Q";
  } else if (frequencies.includes("S")) {
    return "S";
  } else {
    return "A";
  }
};


// WEBPACK FOOTER //
// ./src/components/tree-filter/utils.js